import { bridge, nodes } from "@dinahmoe/dmafjs-core";

class FocusManager {
  engine = "visual";
  focusableNodes = [];
  focusedNodeUids = new Set();
  canFocus = null;

  setupRootComponent(rootComponentUid) {
    this._rootNode = nodes.get(rootComponentUid);
  }

  defaultFocusStrategy(uids) {
    return { uids };
  }

  focusStrategy = this.defaultFocusStrategy;

  setFocusStrategy(strategy) {
    this.focusStrategy = strategy;
  }

  getFocusOptions(targetUids) {
    return this.focusStrategy(targetUids);
  }

  handleFocusEvent(event) {
    const allFocusableNodes = this.getFocusableNodes();
    const targetUids = [];

    for (const node of allFocusableNodes) {
      if (node.element.contains(event.target)) {
        targetUids.push(node.uid);
      }
    }

    this.setFocused(targetUids);
  }

  addFocusableNode(node) {
    this.focusableNodes.push(node);
  }

  removeFocusableNode(uid) {
    this.focusedNodeUids.delete(uid);
    this.focusableNodes = this.focusableNodes.filter(node => node.uid !== uid);
  }

  getFocusableNodes() {
    return this.focusableNodes;
  }

  setFocused(uids, { append = false } = {}) {
    let updatedFocusedNodes = append ? new Set([...this.focusedNodeUids, ...uids]) : new Set(uids);

    const prevFocusedNodes = new Set(this.focusedNodeUids);
    const toUnfocus = [...prevFocusedNodes].filter(uid => !updatedFocusedNodes.has(uid));
    const toFocus = [...updatedFocusedNodes].filter(uid => !prevFocusedNodes.has(uid));
    this.focusedNodeUids = updatedFocusedNodes;

    if (toUnfocus.length) {
      bridge.update({
        uid: "visual/" + this._rootNode.uid,
        value: {
          uids: toUnfocus,
        },
        key: "unfocusNodes",
        sender: "core",
      });
    }

    if (toFocus.length) {
      bridge.update({
        uid: "visual/" + this._rootNode.uid,
        value: {
          uids: toFocus,
        },
        key: "focusNodes",
        sender: "core",
      });
    }
  }

  getFocusedUids() {
    return this.focusedNodeUids;
  }

  getFocusedNodes() {
    return [...this.focusedNodeUids].map(uid => nodes.get(uid));
  }

  clearFocus() {
    this.setFocused([]);
  }
}

const focusManager = new FocusManager();
export { focusManager, FocusManager };
